import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { BfiDataGrid, Column, Summary, TotalItem } from '../../common/SharedComponents';
import { ExperienceTotalTypeOptions, GridSettingType } from '@apply/constants';
import { ExperienceApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';

const Experience20PercentOwnerTotalsTable = ({ principalId, gridStore }) => {
    const searchState = useSelector((state) => state.searchState);
    const experienceApi = new ExperienceApi.ExperienceApi(applicationInsights);
    const [dataStore, set_dataStore] = useState(gridStore?.store);

    const dataFunction = () => {
        return experienceApi.getExperience20PercentOwnerTotals(principalId);
    };

    useEffect(() => {
        if (gridStore) {
            gridStore.setOnLoad('experienceTotalTypeId', dataFunction, searchState?.searchText?.experience);
            set_dataStore(gridStore.store);
        }
    }, [gridStore]);

    const onExperienceTotalTypeRender = (e) => {
        const option = ExperienceTotalTypeOptions.find((a) => a.id === e.value);
        if (!option) {
            return null;
        }
        return option.name;
    };

    const customizeExperienceTotalLabel = useCallback((e) => {
        return 'Totals:';
    });

    const customizeCount = (data) => {
        if (!data) {
            return null;
        }
        return data.value;
    };

    if (!dataStore) {
        return null;
    }

    return (
        <BfiDataGrid
            gridType={GridSettingType.Experiences20PercentOwnerTotalsTable}
            dataStore={dataStore}
            applicationInsights={applicationInsights}
            width={'100%'}
        >
            <Column
                dataField='experienceTotalTypeId'
                caption=''
                alignment='left'
                cellRender={onExperienceTotalTypeRender}
                width={200}
            />
            <Column
                dataField='constructionAmount'
                caption='Construction'
                width={140}
            />
            <Column
                dataField='majorRehabAmount'
                caption='Major Rehab'
                width={140}
            />
            <Column
                dataField='fixFlipAmount'
                caption='Fix-Flip'
                width={140}
            />
            <Column
                dataField='rentalAmount'
                caption='Rental'
                width={140}
            />
            <Summary
                calculateCustomSummary={(e) => {
                    return null;
                }}
            >
                <TotalItem
                    showInColumn='experienceTotalTypeId'
                    customizeText={customizeExperienceTotalLabel}
                />
                <TotalItem
                    column='constructionAmount'
                    summaryType='sum'
                    customizeText={customizeCount}
                />
                <TotalItem
                    column='majorRehabAmount'
                    summaryType='sum'
                    customizeText={customizeCount}
                />
                <TotalItem
                    column='fixFlipAmount'
                    summaryType='sum'
                    customizeText={customizeCount}
                />
                <TotalItem
                    column='rentalAmount'
                    summaryType='sum'
                    customizeText={customizeCount}
                />
            </Summary>
        </BfiDataGrid>
    );
};

export default Experience20PercentOwnerTotalsTable;
